import { Component, OnInit, Input, ViewChild, forwardRef } from '@angular/core';
import { 
   IonGrid, IonRow, IonCol, IonIcon, IonSpinner, InfiniteScrollCustomEvent, IonInfiniteScroll,  IonInfiniteScrollContent 
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import moment from 'moment';

import { MarvTagComponent, MarvMessageComponent, MarvButtonComponent, MarvDrawerComponent } from '@marv/components';
import { MarvDateToStringPipe } from '@marv/pipes';
import { MarvDateService } from '@marv/services';
import { TypeMissionLegend, TypeMissionLegendComponent, MissionItem, MissionDetailsComponent, MissionItemHistoryComponent } from '@app/components';
import { OrderService, MissionTypeService, OperationService } from '@app/services';

@Component({
    selector: 'app-store-details-missions',
    templateUrl: './missions.component.html',
    styleUrls: ['./missions.component.scss'],
    imports: [
        IonGrid, IonRow, IonCol, IonIcon, IonSpinner, IonInfiniteScroll, IonInfiniteScrollContent, TranslatePipe,
        forwardRef(() => MarvDateToStringPipe), forwardRef(() => MarvTagComponent), forwardRef(() => MarvMessageComponent), 
        forwardRef(() => MarvButtonComponent), forwardRef(() => MarvDrawerComponent),
        forwardRef(() => TypeMissionLegendComponent), forwardRef(() => MissionDetailsComponent), forwardRef(() => MissionItemHistoryComponent)
    ]
})
export class StoreDetailsMissionsComponent  implements OnInit {

    @Input({alias : 'storeId', required : true}) storeId: number;
    @Input({alias : 'showDetailsMission', required : false}) showDetailsMission: boolean = true;

    @ViewChild('typeMissionLegend') typeMissionLegend: TypeMissionLegendComponent;
    @ViewChild('drawerMissionDetails') drawerMissionDetails: MarvDrawerComponent;
    
    MarvDateService = MarvDateService;
    isFetching: boolean = false;
    month: Date = new Date();
    tagRealizedDisabled: boolean = false;
    nbMissionsRealized: number = 0;
    tagPlannedDisabled: boolean = false;
    nbMissionsPlanned: number = 0;
    missionsItems:Array<MissionItem> = []; 
    missionsItemsToDisplay: Array<MissionItem> = [];
    missionsItemsDisplayed:Array<MissionItem> = []; 
    maxMissionsItemsDisplayed: number = 50;
    indexOrderDisplayed: number = 0;
    disabledInfiniteScroll: boolean = false;
    
    missionItemSelected: MissionItem|null = null; 
        
    constructor(
        private orderService: OrderService,
        public missionTypeService: MissionTypeService,
    ) { }

    async ngOnInit() {
        this.searchOrders();
    }
    
    async searchOrders(){
        this.isFetching = true;
        let missionsItems: Array<MissionItem> = []; 
        let startDate = MarvDateService.GetFirstDayOfMonth(this.month);
        let endDate = MarvDateService.GetLastDayOfMonth(this.month);
        let orders = await this.orderService.searchOrders(startDate, endDate, this.storeId);
        for(let o of orders){
            missionsItems = missionsItems.concat(o.getMissionsItems(OperationService.OperationsSettings));
        }
        MissionItem.SortItems(missionsItems, 'DESC');
        this.missionsItems = missionsItems;
        this.setMissionsItemsToDisplay();
        this.isFetching = false;
    }
    
    setMissionsItemsToDisplay(){
        
        let typesMissionsActives = this.typeMissionLegend.typesMissions.filter(t => !t.disabled).map(t => t.code); 
        
        this.missionsItemsToDisplay = this.missionsItems.filter(o => 
            (typesMissionsActives.length === 0 || typesMissionsActives.indexOf((o.operation?.typeOfMission || 'PERM')) !== -1)
        );
         
        this.missionsItemsDisplayed = [];
        this.indexOrderDisplayed = 0;
        this.disabledInfiniteScroll = false;
        this.getMissionsItemsDisplayed();
    }
    
    getMissionsItemsDisplayed() {
        let subArray = this.missionsItemsToDisplay.slice(this.indexOrderDisplayed, this.indexOrderDisplayed+this.maxMissionsItemsDisplayed);
        if(subArray.length > 0){
            this.missionsItemsDisplayed = this.missionsItemsDisplayed.concat(subArray);
            this.indexOrderDisplayed += subArray.length;
        }
        else{
            this.disabledInfiniteScroll = true;
        }
    }
    
    async previousMonth(){
        this.month = MarvDateService.GetPreviousMonth(this.month);        
        await this.searchOrders();
    }
    
    async nextMonth(){
        this.month = MarvDateService.GetNextMonth(this.month);      
        await this.searchOrders();
    }
    
    onClickTypeMission(typeMission: TypeMissionLegend){
        this.setMissionsItemsToDisplay();
    }
    
    onClickTagRealized(){
        this.tagRealizedDisabled = !this.tagRealizedDisabled;
    }
    
    onClickTagPlanned(){
        this.tagPlannedDisabled = !this.tagPlannedDisabled;
    }
    
    onIonInfinite(event: InfiniteScrollCustomEvent) {      
        this.getMissionsItemsDisplayed();
        event.target.complete();
    }
    
    onSelectMission(missionItem: MissionItem){
        if(this.showDetailsMission){
            this.missionItemSelected = missionItem;
            this.drawerMissionDetails.open();
        }
    }

    onDidDismissDrawerMission($event: any){
        this.missionItemSelected = null;
    }
        
    async onUpdateMission(status: boolean){   
        if(status){ 
            await this.searchOrders(); 
        }       
    }
    
    async onDeleteMission(status: boolean){
        if(status){
            this.drawerMissionDetails.close();
            await this.searchOrders();
        }
    }
}
